
export const dataFor14 = [["DELFC4 - ggnfc5",2786310, 89.32, 1233], 
["DELFC4 - ggnfc3",2786310, 80.32, 1333],
["DELFC4 - ggnfc6",2786310, 69.32, 5233],
["DELFC4 - ggnfc8",2786310, 39.32, 2233]]

export const dataFor6 = [["ggnfc6",2786310, 89.32, 1233], 
["ggnfc3",2786310, 80.32, 1336],
["ggnfc6",2786310, 69.32, 5733],
["ggnfc8",2786310, 39.32, 2133]]
export const dataFor5 = [["Jaipur",2786310, 89.32, 1233], 
["Chennai",2786310, 80.32, 1333],
["Hyderabad",2786310, 69.32, 5233],
["Ghaziabad",2786310, 39.32, 2233],
["Pune",2786310, 39.32, 2233]]
export const dataFor18 = [["DELFC4 - ggnfc5",2786310, 89.32, 1233], 
["DELFC4 - ggnfc3",2786310, 80.32, 1333],
["DELFC4 - ggnfc6",2786310, 69.32, 5233],
["DELFC4 - ggnfc8",2786310, 39.32, 2233]]
export const dataFor25 = [["Mumbai", "Bangalore",27310, 89.32, "5.3 K"], 
["Mumbai", "Mumbai",6310, 89.32, "5.3 K"],
["Chennai", "Bangalore",8631, 89.32, "1.3 K"],
["Mumbai", "Pune", 8610, 89.32, "4.3 K"],
["Mumbai", "Bangalore",1320, 89.32, "5.3 K"]]
export const dataFor21 = [["fc5", "port",78310, 89.32, 1233], 
["fc25", "port",48310, 89.32, 1233],
["fc3", "port",8310, 89.32, 1233],
["fc1", "port",98310, 89.32, 1233],
["fc3", "port",76310, 89.32, 1233]]
export const dataFor10 = [["DELFC4 - ggnfc5",2786310, 89.32, 1233], 
["DELFC4 - ggnfc3",2786310, 80.32, 1333],
["DELFC4 - ggnfc6",2786310, 69.32, 5233],
["DELFC4 - ggnfc8",2786310, 39.32, 2233]]